import React from "react";
import { useTranslation } from "react-i18next";

function IncidentTimeline({ logs, cardStyle }) {
  const { t } = useTranslation();

  return (

    <div style={cardStyle}>

      <h3>{t("commandCenter.incidentTimeline.title")}</h3>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px"
        }}
      >

        {logs.map((log, index) => (

          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >

            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                background: "#38bdf8"
              }}
            >
            </div>

            <div>

              {typeof log === "string" ? (

                <div
                  style={{
                    fontWeight: "bold"
                  }}
                >
                  {log}
                </div>

              ) : (

                <>
                  <div
                    style={{
                      fontWeight: "bold"
                    }}
                  >
                    {log.time}
                  </div>

                  <div>
                    {t(`commandCenter.telemetryExplanations.${log.message}`, log.message)}
                  </div>
                </>

              )}

            </div>

          </div>

        ))}

      </div>

    </div>

  );

}

export default IncidentTimeline;